<template>
  <div id="disponibilidad-productos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget
            title="VERIFICAR DISPONIBILIDAD PRODUCTO"
            color="primary darken-4"
            dark
          >
            <div slot="widget-content">
              <v-form
                ref="formVerificarProducto"
                :v-model="true"
                lazy-validation
              >
                <v-layout wrap class="container">
                  <v-flex xs12 sm4 md4 lg4>
                    <v-select
                      v-model="sucursalSeleccionada"
                      :items="sucursalesUsuario"
                      :rules="[
                        () => !!sucursalesUsuario || 'El campo es requerido',
                      ]"
                      item-text="nombreSucursal"
                      item-value="sucursalId"
                      label="Selecciona una sucursal"
                      solo
                      return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm4 md4 lg4>
                    <v-combobox
                      v-model="productoSeleccionado"
                      :items="productos"
                      :rules="[
                        () =>
                          productoSeleccionado.productoId !== 0 ||
                          'El campo es requerido',
                      ]"
                      item-text="descripcionProducto"
                      :loading="loadingProductos"
                      item-value="productoId"
                      label="Selecciona el producto que deseas verificar"
                      placeholder="Selecciona el producto que deseas verificar"
                      required
                      @change="loadCatalogo"
                    ></v-combobox>
                  </v-flex>

                  <v-flex xs12 sm4 md4 lg4>
                    <v-combobox
                      v-model="catalogoSeleccionado"
                      :items="catalogoProducto"
                      :rules="[
                        () =>
                          catalogoSeleccionado.catalogoRowId !== 0 ||
                          'El campo es requerido',
                      ]"
                      item-text="descripcionCatalogo"
                      item-value="catalogoRowId"
                      required
                    >
                      <template slot="item" slot-scope="data">
                        <v-icon :color="data.item.colorHtml">widgets</v-icon>
                        <span class="cb-item">{{
                          data.item.descripcionCatalogo
                        }}</span>
                      </template>
                    </v-combobox>
                  </v-flex>

                  <v-flex xs12 sm12 md4 lg4>
                    <v-menu
                      ref="menuFechaInicio"
                      :close-on-content-click="false"
                      v-model="openFechaInicio"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="fechaInicio"
                        :rules="[
                          () => !!fechaInicio || 'El campo es requerido',
                        ]"
                        label="Fecha inicio *"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        ref="picker"
                        v-model="fechaInicio"
                        min="2018-01-01"
                        @change="setFechaInicio"
                        locale="es"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs12 sm12 md4 lg4>
                    <v-menu
                      ref="menuFechaFin"
                      :close-on-content-click="false"
                      v-model="openFechaFin"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :disabled="disabledFechaFin"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="fechaFin"
                        :rules="[() => !!fechaFin || 'El campo es requerido']"
                        label="Fecha fin *"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        ref="pickerFin"
                        v-model="fechaFin"
                        :min="fechaInicio"
                        @change="setFechaFin"
                        locale="es"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs12 sm12 md4 lg4>
                    <v-btn
                      color="primary darken-4"
                      :loading="$store.state.operationInProgress"
                      @click="verificarDisponibilidad"
                      >Verificar disponibilidad</v-btn
                    >
                  </v-flex>

                  <v-flex
                    xs12
                    sm12
                    md12
                    lg12
                    v-if="disponibilidadProducto.catalogoRowId !== 0"
                  >
                    <h4>
                      CANTIDAD EN INVENTARIO:
                      <span class="green--text">{{
                        disponibilidadProducto.cantidadInventario
                      }}</span>
                      / CANTIDAD SOLICITADA:
                      <span class="red--text">
                        {{ disponibilidadProducto.cantidadSolicitada }}
                      </span>
                      | RESULTADO:
                      <span :class="classDisponibilidad">
                        {{ disponibilidad }}
                      </span>
                    </h4>
                  </v-flex>
                </v-layout>
              </v-form>
              <v-layout row wrap>
                <v-flex lg12>
                  <v-data-table
                    :headers="disponibilidadGrid.headers"
                    :search="search"
                    :items="disponibilidadProducto.rentas"
                    :rows-per-page-items="[
                      10,
                      25,
                      50,
                      { text: 'Todos', value: -1 },
                    ]"
                    class="elevation-1"
                    item-key="rentaId"
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <v-avatar size="48">
                          <v-icon color="red" medium>info</v-icon>
                        </v-avatar>
                      </td>
                      <td>{{ props.item.folioRenta }}</td>
                      <td>{{ props.item.nombreCliente }}</td>
                      <td>{{ props.item.fechaRenta.substring(0, 10) }}</td>
                      <td>
                        {{ props.item.fechaRecoleccion.substring(0, 10) }}
                      </td>
                      <td>{{ props.item.fechaEvento.substring(0, 10) }}</td>
                      <td>{{ props.item.fechaEntrega.substring(0, 10) }}</td>
                      <td>
                        <v-layout justify-center
                          ><b class="red--text">{{
                            props.item.cantidadSolicitada
                          }}</b></v-layout
                        >
                      </td>
                    </template>
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="error"
                      icon="warning"
                      outline
                      >La búsqueda para "{{ search }}" no encontró
                      registros</v-alert
                    >
                  </v-data-table>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

//Services
import productoService from "@/services/productoService";
import inventarioService from "@/services/inventarioProductoService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      sucursalesUsuario: [],
      sucursalSeleccionada: {
        sucursalId: 0,
        nombreSucursal: "",
      },
      openFechaInicio: false,
      openFechaFin: false,
      disabledFechaFin: true,
      fechaInicio: null,
      fechaFin: null,
      loadingProductos: false,
      productoSeleccionado: {
        productoId: 0,
        descripcionProducto: "",
      },
      catalogoSeleccionado: {
        catalogoRowId: 0,
        descripcionCatalogo: "",
      },
      productos: [],
      catalogoProducto: [],
      search: "",
      disponibilidadProducto: {
        catalogoRowId: 0,
        cantidadInventario: 0,
        cantidadSolicitada: 0,
        rentas: [],
      },
      disponibilidadGrid: {
        headers: [
          { text: "", align: "red", sortable: false },
          {
            text: "FOLIO RENTA",
            align: "center",
            sortable: true,
            value: "folioRenta",
          },
          { text: "CLIENTE", align: "center", value: "nombreCliente" },
          { text: "FECHA RENTA", align: "center", value: "fechaRenta" },
          { text: "RECOLECCIÓN", align: "center", value: "fechaRecoleccion" },
          { text: "EVENTO", align: "center", value: "fechaEvento" },
          { text: "ENTREGA", align: "center", value: "fechaEntrega" },
          {
            text: "CANTIDAD RENTADA",
            align: "center",
            value: "cantidadSolicitada",
          },
        ],
      },
    };
  },
  watch: {
    sucursalSeleccionada: function (n) {},
  },
  computed: {
    disponibilidad: function () {
      if (
        this.disponibilidadProducto.cantidadInventario <=
        this.disponibilidadProducto.cantidadSolicitada
      ) {
        return "NO DISPONIBLE";
      } else {
        return "DISPONIBLE";
      }
    },
    classDisponibilidad: function () {
      if (
        this.disponibilidadProducto.cantidadInventario <=
        this.disponibilidadProducto.cantidadSolicitada
      ) {
        return "red--text";
      } else {
        return "green--text";
      }
    },
  },
  mounted() {
    let self = this;
    try {
      let current_user = this.$store.state.currentUser;
      this.sucursalesUsuario = current_user.sucursales;
      if (this.sucursalesUsuario.length > 0) {
        this.sucursalSeleccionada = this.sucursalesUsuario[0];
      }
      self.getProductos();
    } catch (e) {
      self.codeFailed(
        "Ocurrió un error al extraer sucursales, es posible que se haya perdido la sesión o no tengas sucursales asignadas"
      );
    }
  },
  methods: {
    setFechaInicio(date) {
      this.$refs.menuFechaInicio.save(date);
      this.disabledFechaFin = false;
    },
    setFechaFin(date) {
      this.$refs.menuFechaFin.save(date);
    },
    loadCatalogo(producto) {
      let self = this;
      productoService
        .getProductoCatalogo(producto.productoId)
        .then((result) => {
          self.catalogoProducto = result.listaCatalogoProducto;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getProductos() {
      let self = this;
      self.loadingProductos = true;
      productoService
        .getAllForDrop()
        .then((result) => {
          self.productos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingProductos = false;
        });
    },
    verificarDisponibilidad() {
      let self = this;
      if (self.$refs.formVerificarProducto.validate()) {
        let inventarioFilter = {
          sucursalId: self.sucursalSeleccionada.sucursalId,
          catalogoRowId: self.catalogoSeleccionado.catalogoRowId,
          fechaInicio: self.fechaInicio,
          fechaFin: self.fechaFin,
        };

        inventarioService
          .verificaDisponibilidad(inventarioFilter)
          .then((result) => {
            console.log(result);
            self.disponibilidadProducto = result;
          })
          .catch((e) => {
            console.log(e);
            self.operationFailed(e);
          })
          .finally(() => {
            self.$store.state.loadingInfo.show = false;
          });
      }
    },
  },
};
</script>

<style>
thead tr th {
  background-color: #00202c;
  color: white !important;
  max-height: 15px;
}
thead tr th i {
  color: white !important;
}
</style>
